import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select'
import  '../src/Services/GlobalVariables'
import "vue-select/dist/vue-select.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
  import VueSignaturePad from 'vue-signature-pad';
Vue.config.productionTip = false
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(VueSignaturePad);
Vue.component('v-select', vSelect)
Vue.use(BootstrapVue)
Vue.component('loading', Loading);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
